import { render, staticRenderFns } from "./CommonFacialDeviceModal.vue?vue&type=template&id=77de8938&scoped=true&"
import script from "./CommonFacialDeviceModal.vue?vue&type=script&lang=js&"
export * from "./CommonFacialDeviceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de8938",
  null
  
)

export default component.exports